(function () {
  'use strict';
  var observer;
  var frame;

  function measure() {
    frame = null;
    var announcement = document.querySelector('.section-announcement-bar .announcement-bar');
    var root = document.querySelector('.rr-home-overlay-header');
    var header = root && root.querySelector('[data-rr-home-header]');
    var announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var html = document.documentElement;
    var announcementValue = announcementHeight + 'px';
    var headerValue = headerHeight + 'px';

    if (html.style.getPropertyValue('--rr-announcement-height') !== announcementValue) {
      html.style.setProperty('--rr-announcement-height', announcementValue);
    }
    if (header && headerHeight > 0) {
      if (html.style.getPropertyValue('--rr-header-height') !== headerValue) {
        html.style.setProperty('--rr-header-height', headerValue);
      }
      if (root.style.getPropertyValue('--rr-header-height') !== headerValue) {
        root.style.setProperty('--rr-header-height', headerValue);
      }
    }
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(measure);
  }

  function connect() {
    if (observer) observer.disconnect();
    var announcement = document.querySelector('.section-announcement-bar .announcement-bar');
    var header = document.querySelector('[data-rr-home-header]');
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      if (announcement) observer.observe(announcement);
      if (header) observer.observe(header);
    }
    schedule();
  }

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  connect();
})();
